import React, { CSSProperties,useEffect, useRef, useState } from "react";
import classes from "./DiagnosisExternal.module.scss";
import { useSearchParams,useNavigate } from "react-router-dom";
import Header from "../../molecules/header/Header";
import {
  fetchSimulationList,
  SimulationList,
} from "../../api/SimulationListApi";
import {
  postExternalSimulation
} from "../../api/SimulationExternalApi";

const DiagnosisExternal = () => {
  const fetchSimulationListApi = fetchSimulationList();
  const postExternalSimulationApi = postExternalSimulation();
  const [searchParams] = useSearchParams();
  const [target, setTarget] = useState<SimulationList | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e: MessageEvent) => {
      if (e.data?.type === "NAVIGATE" && typeof e.data.path === "string") {
        navigate(e.data.path);
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [navigate]);


  const type = searchParams.get("type");
  const id = searchParams.get("id");
  // ★ 一度だけ setTarget したかどうか
  const hasSetTargetRef = useRef(false);

  useEffect(() => {
    if (type === "simulation" && id != null) {
      fetchSimulationListApi.fetch();
    }
  }, [type, id, fetchSimulationListApi]);

  useEffect(() => {
    const data = fetchSimulationListApi.state?.data;
    if (!data || !id) return;

    // setTarget 済なら何もしない
    if (hasSetTargetRef.current) return;

    const tmp = data.find(d => d.simulationId === id);
    if (!tmp) return;

    setTarget(tmp);
    hasSetTargetRef.current = true; 
  }, [fetchSimulationListApi.state?.data, id]);

  // target が「初めて」決まったタイミングで一度だけ POST
  // 診断ステータス、ポイント付与ロジック、シュミレーション実行回数をアップデート
  const hasPostedRef = useRef(false);
  useEffect(() => {
    if (!target || hasPostedRef.current) return;
    postExternalSimulationApi.post({ simulationId: target.simulationId });
    hasPostedRef.current = true;
  }, [target, postExternalSimulationApi]);

  const getStyle: () => CSSProperties = () => ({ height: `${window.innerHeight - 60}px` });

  return (
    <div className={classes.container}>
      <Header />
      {target && (
        <div className={classes.wrapper}>
          <iframe
            src={target.externalUrl}
            style={getStyle()}
            className={classes.iframe}
            title="埋め込みコンテンツ"
          />
        </div>
      )}
    </div>
  );
};
export default DiagnosisExternal;